var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive } ]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('user-menu'),_c('mobile-menu'),_c('template',{slot:"links"},[(_vm.$route.meta.rtlActive)?_c('sidebar-item',{attrs:{"link":{
          name: 'لوحة القيادةة',
          icon: 'dashboard',
          path: '/dashboard',
        }}}):_c('sidebar-item',{attrs:{"link":{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Work',
          path: '/antony/work/list',
          icon: 'library_music',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Version',
          path: '/antony/version/list',
          icon: 'timeline',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Software',
          icon: 'widgets',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Softwares',
            path: '/antony/software/list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Categories',
            path: '/antony/software-categorie/list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'OS',
            path: '/antony/os/list',
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Hardware',
          icon: 'handyman',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Hardwares',
            path: '/antony/hardware/list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Categories',
            path: '/antony/hardware-categorie/list',
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'User',
          path: '/antony/user/list',
          icon: 'people',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Organization',
          path: '/antony/organization/list',
          icon: 'corporate_fare',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Licence',
          path: '/antony/licence/list',
          icon: 'local_police',
        }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Maps', icon: 'place' }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Google Maps', path: '/maps/google' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Full Screen Maps', path: '/maps/full-screen' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Vector Maps', path: '/maps/vector-map' }}})],1),_c('sidebar-item',{attrs:{"link":{ name: 'Charts', icon: 'timeline', path: '/charts' }}}),(_vm.$route.meta.rtlActive)?_c('sidebar-item',{attrs:{"link":{ name: 'التقويم', icon: 'date_range', path: '/calendar' }}}):_c('sidebar-item',{attrs:{"link":{ name: 'Calendar', icon: 'date_range', path: '/calendar' }}})],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('fixed-plugin',{attrs:{"color":_vm.sidebarBackground,"colorBg":_vm.sidebarBackgroundColor,"sidebarMini":_vm.sidebarMini,"sidebarImg":_vm.sidebarImg,"image":_vm.sidebarBackgroundImage},on:{"update:color":function($event){_vm.sidebarBackground=$event},"update:colorBg":function($event){_vm.sidebarBackgroundColor=$event},"update:color-bg":function($event){_vm.sidebarBackgroundColor=$event},"update:sidebarMini":function($event){_vm.sidebarMini=$event},"update:sidebar-mini":function($event){_vm.sidebarMini=$event},"update:sidebarImg":function($event){_vm.sidebarImg=$event},"update:sidebar-img":function($event){_vm.sidebarImg=$event},"update:image":function($event){_vm.sidebarBackgroundImage=$event}}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }